// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"AudioPlayer_audioPlayer__VuO9X","mode-simple":"AudioPlayer_mode-simple__7K5_c","mode-full":"AudioPlayer_mode-full__LYkqX"};